import React from "react";
import { createPortal } from "react-dom";
import { Toast, ToastContainer } from "react-bootstrap";

export default function AppToast({
  show,
  message,
  variant = "success",
  type,
  onClose,
  sticky = false,
  delay = 3000,
}) {
  const variantOrType = type || variant || "success";
  const effectiveVariant = variantOrType === 'danger' ? 'danger' : variantOrType;
  /** Bootstrap warning/info/light use bright backgrounds — white text fails WCAG contrast. */
  const lightBackground =
    effectiveVariant === 'warning' ||
    effectiveVariant === 'info' ||
    effectiveVariant === 'light';
  const bodyTextClass = lightBackground ? 'text-dark' : 'text-white';
  const closeBtnClass = lightBackground ? 'btn-close' : 'btn-close btn-close-white';
  const toastContent = (
    <ToastContainer
      position="top-center"
      className="p-3 app-toast-container"
      style={{
        zIndex: 99999,
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        pointerEvents: 'none'
      }}
    >
      <Toast
        onClose={onClose}
        show={show}
        delay={sticky ? false : delay}
        autohide={!sticky}
        bg={effectiveVariant}
        style={{
          minWidth: '450px',
          fontSize: '16px',
          fontWeight: '500',
          pointerEvents: 'auto',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          border: effectiveVariant === 'danger' ? '2px solid #dc3545' : 'none'
        }}
      >
        <Toast.Body
          className={`${bodyTextClass} d-flex align-items-center justify-content-between`}
          style={{ padding: '15px 20px' }}
        >
          <div className="d-flex align-items-center">
            <i
              className={`fas fa-${
                effectiveVariant === 'success'
                  ? 'check-circle'
                  : effectiveVariant === 'danger'
                    ? 'exclamation-triangle'
                    : effectiveVariant === 'warning'
                      ? 'exclamation-circle'
                      : 'info-circle'
              } me-3`}
              aria-hidden
            />
            <span>{message}</span>
          </div>
          {sticky && (
            <button
              type="button"
              className={closeBtnClass}
              onClick={onClose}
              style={{ marginLeft: '15px' }}
              aria-label="Close"
            />
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
  return createPortal(toastContent, document.body);
}
